// import { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";

export default function PageNotFound({ isNotFound }) {
  // const { lang, pages } = useSelector((state) => state);
  // const [firstPage, setFirstPage] = useState();
  // useEffect(() => {
  //   setFirstPage(pages[0]?.page_id);
  // }, [pages]);

  // const navigate = useNavigate();

  return (
    <div classNameName="inner_page login">
      <div class="full_container">
        <div class="container">
          <div class="center verticle_center full_height">
            <div class="error_page">
              <div class="center">
                <div class="error_icon">
                  <img
                    class="img-responsive"
                    src="/images/layout_img/error.png"
                    alt="#"
                  />
                </div>
              </div>
              <br />
              <h3>PAGE NOT FOUND !</h3>
              <p>YOU SEEM TO BE TRYING TO FIND HIS WAY HOME</p>
              {isNotFound ? null : (
                <div class="center">
                  <a class="main_bt" onClick={() => window.history.back()}>
                    Go To Home Page
                  </a>
                  {/* <a class="main_bt" href={firstPage ? firstPage : "/login"}>
                    Go To Home Page
                  </a> */}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
